export const VOUCHER_CARD_WIDTH = '282px';